import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import 'moment/locale/pt-br';
import 'sanitize.css';

import { fetchActiveWidgets } from '#/api/widgetService';
import { fetchFilters } from '#/api/filterService';
import TabsProvider from '#/contexts/tabscontexts';
import Workspace from '#/containers/Workspace';
import useCookie from '#/hooks/useCookie';
import useOriginHost from '#/hooks/useOriginHost';
import Loading from '#/components/Loader';
import Modal from '#/components/Modal';
import useModal from '#/hooks/useModal';
import DashboardContext from '#/context';
import moment from 'moment';

import './utils/i18n'

import { useTranslation } from "react-i18next";


moment.locale('pt-BR');

const App = () => {
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState([]);
  const [polling, setPolling] = useState(0);
  const [localFilters, setLocalFilters] = useState({
    businessUnitIds: [],
    clientIds: [],
    workplaceIds: [],
    companyIds: [],
    personTemplate: false
  });
  const [widgets, setWidgets] = useState([]);
  const [tempDashboard, setTempDashboard] = useState([]);
  const [activeDashboard, setActiveDashboard] = useState([]);
  const [stateDashboard, setStateDashboard] = useState({
    edit: false,
    board: false,
  });
  const [date, setDate] = useState({
    startDate: moment().startOf('month'),
    endDate: moment(),
  });
  const { modal, toggleModal } = useModal();
  const { hasCookie, validateCookie } = useCookie();
  const { hasOriginHost, loadOriginHost } = useOriginHost();

  const { t } = useTranslation();


  useEffect(() => {
    const pollingStorage = localStorage.getItem('polling');
    const localFilters = localStorage.getItem('localFilters');
    
    if (pollingStorage) setPolling(parseInt(pollingStorage));

    if (localFilters) setLocalFilters(JSON.parse(localFilters));
    loadOriginHost();
    validateCookie();
    if (hasCookie && hasOriginHost) {
      fetchData();
    }
  }, [hasCookie, hasOriginHost, date]);

  async function fetchData() {
    try {
      const filters = await fetchFilters();
      setFilters(filters.data);
      const { data } = await fetchActiveWidgets();
      if (!data.length) {
        setActiveDashboard([
          ...activeDashboard,
          {
            id: '1',
            name: t('UNTITLED'),
            ordination: 1,
            widgets: [],
            defaultDashboard: true
          },
        ]);
      } else {
        const newData = data.map(dash => {
          return {
            widgets: [],
            ...dash,
          };
        });
        setActiveDashboard(newData);
      }
      setLoading(false);
    } catch ({ response }) {
      setLoading(false);
      if (response.status === 401)
        return toggleModal(
          t('SESSION_HAS_BEEN_EXPIRED')
        );
      toggleModal(
        t('CANNOT_START_DASHBOARD')
      );
    }
  }

  return (
    <DashboardContext.Provider
      value={{
        date,
        setDate,
        filters,
        localFilters,
        setLocalFilters,
        widgets,
        setLoading,
        setWidgets,
        tempDashboard,
        setTempDashboard,
        activeDashboard,
        setActiveDashboard,
        stateDashboard,
        setStateDashboard,
        polling,
        setPolling,
      }}
    >
      <Modal
        title={t('SOMETHING_WENT_WRONG')}
        isOpen={modal.isOpen}
        onClose={() => {
          toggleModal();
          let frontUrl = '';
          if(process.env.REACT_APP_URL_API.includes('localhost')) {
            frontUrl = 'localhost:9000';
          } else if (process.env.REACT_APP_URL_API.includes('api.qa.nexti.com')) {
            frontUrl = 'qa.nexti.com';
          } else if (process.env.REACT_APP_URL_API.includes('api.nexti.com')) {
            frontUrl = 'nexti.com';
          }

          window.top.location.href = window.location.protocol+"//app."+frontUrl;
        }}
      >
        {modal.message}
      </Modal>
      <TabsProvider tempDashboard ={tempDashboard} setTempDashboard={setTempDashboard}>
         <Workspace />
      </TabsProvider>
      {loading && <Loading shape="fullScreen" />}
    </DashboardContext.Provider>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));
